const browsers = [
  'Chrome',
  'Safari',
  'Edge',
  'Firefox'
];

const hrefs = {
  [browsers[0]]: 'https://www.google.com/chrome/',
  [browsers[1]]: 'https://www.apple.com/safari/',
  [browsers[2]]: 'https://www.microsoft.com/windows/microsoft-edge',
  [browsers[3]]: 'https://www.mozilla.org/firefox/new/'
};

const browserNormalizations = {
  'Microsoft Edge': 'Edge',
  'Samsung Internet for Android': 'Samsung Internet'
};

export {
  browsers,
  browserNormalizations,
  hrefs
};
